import { Stack } from "@mui/material";
import React from "react";
import Introduction from "./Introduction";
import MobileSection1 from "./MobileSection1";

const PerformanceMetricsMobile = () => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        backgroundImage: `url(./heroBg/morning.svg)`,
      }}
    >
      <Stack
        sx={{
          //   border: "1px solid grey",
          width: { xs: "93%" },
          gap: 2,
          height: "100%",

        }}
      >
        <Stack>
          <Introduction />
        </Stack>
        <Stack>
          <MobileSection1 />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PerformanceMetricsMobile;
